import React from 'react';
import KPIMaster from './KPI_Master';
import '../../../CommonCSS/SocietyCSS.css'

const KPI_MasterApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>KPI Master</h5>
          </div>
        </div>
        <KPIMaster/>
      </div>
    </div >
  );
};

export default KPI_MasterApp;
